
import axios from 'axios';

// 创建axios实例
const service = axios.create({
  baseURL:'https://www.chezhency.com/home',
  timeout: 3000000000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor(响应拦截器)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status == 1) {
      return res
    } else if (res.status == -100) {
      location.reload();
    } else {
      return res
    }

  },
  error => {
    console.log('请求出错!请联系技术人员!')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js